export const AUTH_ENDPOINTS = {
  usersGetOtpV1: (smsType: number) => ({
    regular: `v1/users/get-otp?smsType=${smsType}`,
    secure: `v1/users/get-otp-secure?smsType=${smsType}`,
  }),
  usersGetOtpRegisterV3: (smsType: number) => ({
    regular: `v3/users/get-otp-register?smsType=${smsType}`,
    secure: `v3/users/get-otp-register-secure?smsType=${smsType}`,
  }),
  usersResendOtpV1: (smsType: number) => ({
    regular: `v1/users/resend-otp?smsType=${smsType}`,
    secure: `v1/users/resend-otp-secure?smsType=${smsType}`,
  }),
  otpV3: (smsType?: number) => {
    const query = smsType !== undefined ? `?smsType=${smsType}` : ''
    return {
      regular: `/v3/otp${query}`,
      secure: `/v3/otp-secure${query}`,
    }
  },
} as const
